var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_71_1915)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.3214 45.5218L83.166 30.3663V12.8592C83.166 9.69362 80.6007 7.12821 77.4306 7.12821C74.2677 7.12821 71.7025 9.69362 71.7025 12.8592V18.903L60.418 7.61812C54.8388 2.042 45.1386 2.05189 39.5721 7.62821L1.67774 45.5218C-0.559247 47.7632 -0.559247 51.39 1.67774 53.628C3.91574 55.8688 7.54959 55.8688 9.78678 53.628L47.6775 15.7334C48.9119 14.5055 51.0875 14.5055 52.3154 15.7298L90.2126 53.628C91.3364 54.7485 92.8014 55.3058 94.2661 55.3058C95.7338 55.3058 97.2013 54.7479 98.3217 53.628C100.559 51.3902 100.559 47.7634 98.3214 45.5218Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.9908 26.6121C50.8899 25.5118 49.1073 25.5118 48.0096 26.6121L14.6776 59.9342C14.1514 60.4603 13.853 61.1785 13.853 61.928V86.2319C13.853 91.935 18.4772 96.5589 24.1801 96.5589H40.6828V71.0017H59.314V96.5589H75.8169C81.5196 96.5589 86.1438 91.935 86.1438 86.2321V61.928C86.1438 61.1785 85.8481 60.4603 85.3192 59.9342L51.9908 26.6121Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_71_1915"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/HomeIcon.61c9fbb6e11728a9b701d7190abc4098.svg";
export { ForwardRef as ReactComponent };